// auto created file
import { COLOR_PALETTE } from "../constants/colors";

export const normalizeStateKey = (employee) => {
  const raw = employee?.employeeState ?? employee?.status ?? employee?.state ?? "";
  const str = typeof raw === "string" ? raw : String(raw || "");
  return str.trim().toLowerCase().replace(/\s+/g, "");
};

export const buildDepartmentStatsFromEmployees = (employees, totalOverride) => {
  const departmentCounts = new Map();
  employees.forEach((emp) => {
    const source =
      emp?.employeeType ??
      emp?.department ??
      emp?.departmentName ??
      emp?.dept ??
      "Unassigned";
    const name = (() => {
      if (typeof source === "string") {
        const trimmed = source.trim();
        return trimmed.length ? trimmed : "Unassigned";
      }
      const value = String(source || "").trim();
      return value.length ? value : "Unassigned";
    })();
    departmentCounts.set(name, (departmentCounts.get(name) || 0) + 1);
  });

  const total = totalOverride ?? employees.length;

  return Array.from(departmentCounts.entries())
    .map(([name, count], index) => ({
      name,
      count,
      percentage: total > 0 ? Math.round((count / total) * 100) : 0,
      color: COLOR_PALETTE[index % COLOR_PALETTE.length],
    }))
    .filter((item) => item.count > 0);
};

export const flattenHierarchyNodes = (nodes) => {
  if (!Array.isArray(nodes)) return [];
  const stack = [...nodes];
  const result = [];
  const seen = new Set();

  while (stack.length) {
    const current = stack.pop();
    if (!current || typeof current !== "object") continue;

    const identifier = current.infinityCode || current.employeeCode || current.id;
    if (identifier && seen.has(identifier)) continue;
    if (identifier) seen.add(identifier);

    result.push(current);

    const childCollections = [current.children, current.subordinates];
    childCollections.forEach((childList) => {
      if (Array.isArray(childList)) {
        for (let i = childList.length - 1; i >= 0; i -= 1) {
          stack.push(childList[i]);
        }
      }
    });
  }

  return result;
};

export const extractEmployeesFromPayload = (payload) => {
  if (!payload) return [];
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload.employees)) return payload.employees;
  if (payload.data) {
    if (Array.isArray(payload.data)) return payload.data;
    if (Array.isArray(payload.data.employees)) return payload.data.employees;
  }
  return [];
};

export const extractWorkingCompanyName = (employee) => {
  const source =
    employee?.workingCompany ??
    employee?.company ??
    employee?.contractCompany ??
    employee?.clientCompany ??
    employee?.Company ??
    "";

  if (typeof source === "string") {
    const trimmed = source.trim();
    return trimmed.length ? trimmed : "";
  }

  return String(source || "").trim();
};

export const getStoredUserInfo = () => {
  if (typeof window === "undefined") return null;
  const raw = localStorage.getItem("user") || sessionStorage.getItem("user");
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch (error) {
    console.warn("Failed to parse stored user info:", error);
    return null;
  }
};

export const getStoredAdminLevel = () => {
  if (typeof window === "undefined") return null;
  const raw = localStorage.getItem("adminLevel");
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch (error) {
    console.warn("Failed to parse stored admin level:", error);
    return null;
  }
};

export const getDepartmentStatsArray = (rawDeptData) => {
  if (Array.isArray(rawDeptData)) return rawDeptData;
  if (rawDeptData && Array.isArray(rawDeptData.data)) return rawDeptData.data;
  if (rawDeptData && Array.isArray(rawDeptData.departments)) return rawDeptData.departments;
  if (rawDeptData && Array.isArray(rawDeptData.stats)) return rawDeptData.stats;
  return [];
};